export default __webpack_public_path__ + "23ee0d9421305b03066f854e3afbc140.png";